module.exports = __webpack_public_path__ + "img/desc1.541ef78c.jpg";